interface InlineErrorBannerProps {
  message?: string | string[]
}

export function InlineErrorBanner({ message }: InlineErrorBannerProps) {
  if (!message || (Array.isArray(message) && message.length === 0)) {return null}

  return (
    <div className="mb-6 rounded-[8px] border border-destructive/40 bg-destructive/10 px-4 py-3 font-sans text-[13px] text-destructive">
      {Array.isArray(message) ? message.join(', ') : message}
    </div>
  )
}
